/* eslint-disable array-callback-return */

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import {
    Box, FormControlLabel, Switch, TableRow, TableCell, Checkbox, Button, TextField
} from "@mui/material";
import { Col, Image, Row, Space } from "antd";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import MainHeader from "../../../../Shared/components/Header";
import { useParams, NavLink } from "react-router-dom";
import usePrevious from "../../../../Shared/components/Previous";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard.js";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import crudActions from "../../../../CRUD/redux/actions";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import PrimaryTable from "../../../../Shared/components/PrimaryTable";
import { featurePermisionHead, componentPermisionHead, clientTaggingHead } from "../../../../../config/constant";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import ComponentTable from './ComponentTable';
import ClientTable from './ClientTable';
import actions from "../../redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import { checkCRUDViewPermission, checkCRUDPermission } from "../../../../../helpers/utilities";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";

const RoleEdit = (props) => {
    const { readDetails, createDetails, createError, createLoader, editDetails, editError, } = useSelector(state => state.crudReducer);
    const { featureDetails, featureComponentDetails, componentDetails } = useSelector(state => state.younoteAdminSecuritySetupReducer);
    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;

    const [iconAnimation, setIconAnimation] = useState(false);
    const { roleId } = useParams();
    const [value, setValue] = useState("Feature");
    const [visible, setVisible] = useState(false);
    const [clientVisible, setClientVisible] = useState(false);
    const [componentVisible, setComponentVisible] = useState(false);
    const [showDetails, setShowDetails] = useState(true);
    const [featureData, setFeatureData] = useState([]);
    const [featureExtraData, setFeatureExtraData] = useState([]);
    const [componentData, setComponentData] = useState([]);
    const [componentExtraData, setComponentExtraData] = useState([]);
    const [tabSetting, setTabSetting] = useState('feature');
    const [errorComponentId, setErrorComponentId] = useState(false);
    const [errorFeatureId, setErrorFeatureId] = useState(false);
    const [search, setSearch] = useState('');
    const prevReadDetails = usePrevious(readDetails);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const timeoutRef = useRef(null);
    const prevSearch = usePrevious(search);
    const dispatch = useDispatch();

    useEffect(() => {
        if (prevReadDetails !== undefined && readDetails && prevReadDetails !== readDetails) {
            setShowDetails(false);
            setFeatureData(readDetails?.featurePermissions || []);
            setComponentData(readDetails?.componentPermissions);
            searchFunction(search);
        }
    }, [readDetails, prevReadDetails]);

    const [form, setForm] = useState({
        featureId: "",
        create: false,
        view: false,
        edit: false,
        deletable: false,
        full: false,
        roleId: parseInt(roleId)
    });

    const loadTasks = useCallback(() => {
        dispatch({
            type: actions.FEATURE_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: actions.COMPONENT_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
        dispatch({
            type: actions.FEATURE_COMPONENT_DETAILS_START, filter: {
                order: 'id  desc'
            }
        });
        dispatch({ type: crudActions.READ_DETAILS_START, id: roleId, url: "role" });
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (roleManagement !== '' && checkCRUDViewPermission('Security Roles', 'edit', history, 'Younote Admin')) {
            loadTasks();
        }
    }, [roleManagement]);

    const handleOpen = (data = '') => {
        emptyState();
        emptyStateInput();
        if (data === 'client') {
            setClientVisible(true);
        } else {
            setVisible(true);
        }
    };

    const emptyState = () => {
        setErrorFeatureId(false);
        setErrorComponentId(false);
    }

    const changeComponentVisible = (data) => {
        setComponentVisible(data);
        setErrorComponentId(false);
    }

    const emptyStateInput = () => {
        setForm({
            ...form,
            featureId: "",
            create: false,
            view: false,
            edit: false,
            deletable: false,
            full: false
        });
    }

    const addFeature = (e) => {
        e.preventDefault();
        let emptyFeatureId = emptyValidation('Feature', form.featureId, 'dropDown');
        emptyState();
        if (emptyFeatureId.isValid) {
            delete form.full;
            dispatch({
                type: crudActions.CREATE_DETAILS_START,
                url: 'featurePermissions',
                title: 'Feature Permissions',
                details: form
            });
        } else {
            if (emptyFeatureId.errors) {
                setErrorFeatureId(emptyFeatureId.errors);
            }
        }
    }

    const featureObject = () => {
        let a = featureDetails && featureDetails.filter(function (el) { return el.id === form.featureId });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    };

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form,
                [name]: e,
            });
        } else if (e.target.name === 'full') {
            if (e.target.checked) {
                setForm({
                    ...form,
                    'edit': true,
                    'view': true,
                    'create': true,
                    'deletable': true,
                    'full': true,
                });
            } else {
                setForm({
                    ...form,
                    'edit': false,
                    'view': false,
                    'create': false,
                    'deletable': false,
                    'full': false,
                });
            }
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value,
            });
        }
    }

    const handleClose = (data = '') => {
        emptyStateInput();
        emptyState();
        if (data === 'client') {
            setClientVisible(false);
        } else {
            setVisible(false);
        }
    };

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            toast.dismiss();
            toast(createDetails);
            emptyStateInput();
            if (visible || clientVisible || componentVisible) {
                setVisible(false);
                setClientVisible(false);
                dispatch({ type: crudActions.READ_DETAILS_START, id: roleId, url: "role" });
            } else {
                if (roleManagement !== '' && checkCRUDPermission('Security Roles', 'view', 'Younote Admin')) {
                    history.push(`/younote-admin/security-setup/security-roles/${parseInt(roleId)}/view`)
                }
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let text = createError.error.message;
            if (text.includes("ER_DUP_ENTRY")) {
                if (componentVisible) {
                    setErrorComponentId("Component already exits");
                } else {
                    setErrorFeatureId("Feature already exits");
                }
            }
        }
    }, [createDetails, createError]);


    const handleFeatureSubmit = (e, data, title) => {
        e.preventDefault();
        data && data.length > 0 && data.map((element, i) => {
            let mLines = {
                ...element
            };
            delete mLines.id; delete mLines.feature; delete mLines.component; delete mLines.roleId;
            data.splice(i, 1, mLines);
        });

        dispatch({
            type: crudActions.CREATE_DETAILS_START,
            url: `role/${parseInt(roleId)}/update${title}Permission`,
            title: `${title} Permissions`,
            details: data
        });
    }

    const changeFeatureHandler = (data, id, e) => {
        let mLines = {
            ...data,
            [e.target.name]: e.target.checked
        };

        featureData.splice(id, 1, mLines);
        setFeatureData((prevState) => {
            return [...featureData];
        });

        let index = featureExtraData.findIndex((d, i) => d.featureId === data.featureId);
        if (index >= 0) {
            featureExtraData.splice(index, 1, mLines);
            setFeatureExtraData((prevState) => {
                return [...featureExtraData];
            });
        } else {
            setFeatureExtraData((prevState) => {
                return [...prevState, mLines];
            });
        }
    }

    const changeComponentHandler = (data, e) => {
        let mLines = {
            ...data,
            [e.target.name]: e.target.checked
        };

        let index = componentData.findIndex((d, i) => d.componentId === data.componentId);

        componentData.splice(index, 1, mLines);
        setComponentData((prevState) => {
            return [...componentData];
        });

        let eIndex = componentExtraData.findIndex((d, i) => d.componentId === data.componentId);
        if (eIndex >= 0) {
            componentExtraData.splice(eIndex, 1, mLines);
            setComponentExtraData((prevState) => {
                return [...componentExtraData];
            });
        } else {
            setComponentExtraData((prevState) => {
                return [...prevState, mLines];
            });
        }
    }


    const handleChangeTab = (data) => {
        setTabSetting(data);
    }


    const featureCustomDetails = () => {
        return featureDetails && featureDetails.filter((el) => {
            return readDetails?.featurePermissions ? readDetails?.featurePermissions.every(f => f.featureId !== el.id) : featureDetails;
        });
    }


    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            timeoutRef.current = setTimeout(() => {
                timeoutRef.current = null;
                searchFunction(search);
            }, 500);
        }
    }, [search]);

    const searchFunction = (search) => {
        if (search === '') {
            setFeatureData(readDetails?.featurePermissions);
        } else {
            let a = readDetails?.featurePermissions?.filter((el) => {
                return (el?.feature?.featureName.match(new RegExp(search, "i")))
            });
            setFeatureData(a);
        }
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            dispatch({ type: crudActions.READ_DETAILS_START, id: roleId, url: "role" });
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            toast.dismiss();
            toast.error(editError.error.message);
        }
    }, [editDetails, editError]);

    const handleGlobalRole = () => {
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: 'role',
            title: 'Role',
            id: roleId,
            details: { globalRole: !readDetails.globalRole }
        });
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader {...props}
                cls={'newImg'}
                img={SettingsImg}
                title={'Younote Admin'}
                links={[{ 'label': 'Younote Admin', 'link': '/younote-admin' }, { 'label': 'Security Roles', 'link': '' }]}
            />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Security Roles'}
                    customClass={classes.customerSettlement}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                        <TextField autoComplete='one-time-code'
                                            placeholder='Search'
                                            type='search'
                                            className={classes.comInput}
                                            required
                                            variant={'standard'}
                                            onChange={(e) => setSearch(e.target.value)}
                                            fullWidth
                                            onFocus={() => setIconAnimation(true)}
                                            onBlur={() => setIconAnimation(false)}
                                        />
                                        <Image src={SearchIcon} preview={false} />
                                    </div>
                                </Col>
                                <Col style={{ paddingLeft: '10px' }}
                                    xxl={3} xl={3} lg={3} md={3} sm={3} xs={12}><span className={clsx(classes.bold)}>{readDetails?.name}</span></Col>
                                <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={12}>
                                    {
                                        showDetails === false && readDetails &&
                                        <FormControlLabel
                                            label="Available for All Clients"
                                            labelPlacement="end"
                                            name={"globalRole"}
                                            onChange={() => handleGlobalRole()}
                                            className={clsx(classes.switchAlignfont14, classes.switchAlign, classes.availableClients, classes.bold)}
                                            control={
                                                <Switch
                                                    className={clsx(classes.customSwitch)}
                                                    size="small" name="" checked={readDetails?.globalRole} />
                                            }
                                        />
                                    }
                                </Col>
                                <Col xxl={10} xl={9} lg={8} md={6} sm={3} xs={24} className={clsx(classes.textAlignRight, classes.removeUnderline)}>
                                    <Space direction="horizontal" align="center" size={[20, 20]}>
                                        {
                                            tabSetting === 'client' ? (
                                                <NavLink
                                                    to="#"
                                                    onClick={() => handleOpen('client')}
                                                    className={clsx(classes.margin20r, classes.customLink, classes.disInline, classes.cursor)}
                                                >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Client</span>
                                                </NavLink>
                                            ) : (
                                                <NavLink
                                                    to="#"
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.margin20r, classes.customLink, classes.disInline, classes.cursor)}
                                                >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Feature</span>
                                                </NavLink>
                                            )
                                        }
                                        {
                                            tabSetting === 'feature' ? (
                                                <NavLink to="#" onClick={(e) => handleFeatureSubmit(e, featureExtraData, 'Feature')} className={clsx(classes.modalBtn, classes.marginRight0, { [classes.loadingA]: createLoader })}>Save</NavLink>
                                            ) : (
                                                <NavLink to="#" onClick={(e) => handleFeatureSubmit(e, componentExtraData, 'Component')} className={clsx(classes.modalBtn, classes.marginRight0, { [classes.loadingA]: createLoader })}>Save</NavLink>
                                            )
                                        }

                                    </Space>
                                </Col>
                            </Row>
                            <TabContext value={value}>
                                <Box className={classes.tabDesign}>
                                    <TabList onChange={handleChange} >
                                        <Tab
                                            className={classes.Bordertab_1}
                                            onClick={() => handleChangeTab('feature')}
                                            label="Feature Permissions" value={"Feature"} />
                                        <Tab className={classes.Bordertab_2}
                                            onClick={() => handleChangeTab('component')}
                                            label="Component Permissions" value={"Component"} />
                                        <Tab className={classes.Bordertab_2}
                                            onClick={() => handleChangeTab('client')}
                                            label="Client Tagging" value={"Client"} />
                                    </TabList>
                                </Box>
                                <TabPanel value={"Feature"}>
                                    <Row className={clsx(classes.scrollParent)}>
                                        <Col span={24}>
                                            <Row className={clsx(classes.customRow)}>
                                                <PrimaryTable
                                                    heads={featurePermisionHead.slice(1)}
                                                    width={true}
                                                    component={
                                                        <>
                                                            {
                                                                showDetails === false && featureData && featureData?.length > 0 && featureData?.map((data, i) => (

                                                                    <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} className={classes.scrollParentIcons}>
                                                                        <TableCell>{data?.feature?.featureName}</TableCell>
                                                                        <TableCell>{data?.feature?.module?.module}</TableCell>
                                                                        <TableCell><Checkbox name={"create"} onChange={(e) => { changeFeatureHandler(data, i, e) }} checked={data?.create} /></TableCell>
                                                                        <TableCell><Checkbox name={"view"} onChange={(e) => { changeFeatureHandler(data, i, e) }} checked={data?.view} /></TableCell>
                                                                        <TableCell><Checkbox name={"edit"} onChange={(e) => { changeFeatureHandler(data, i, e) }} checked={data?.edit} /></TableCell>
                                                                        <TableCell className={classes.textAlignLeft}><Checkbox name={"deletable"} onChange={(e) => { changeFeatureHandler(data, i, e) }} checked={data?.deletable} /></TableCell>
                                                                    </TableRow>
                                                                ))
                                                            }
                                                            {
                                                                showDetails === false && featureData && featureData?.length === 0 &&
                                                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                    <TableCell style={{ textAlign: "center" }} colSpan={5}> <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'No results found'}</p></TableCell>
                                                                </TableRow>
                                                            }
                                                            {
                                                                showDetails === true && (
                                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                                        <TableCell style={{ textAlign: "center" }} colSpan={5}><div className={classes.loadMoreCircle}></div></TableCell>
                                                                    </TableRow>
                                                                )
                                                            }
                                                        </>
                                                    }
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </TabPanel>
                                <TabPanel value={"Component"}>
                                    <Row className={clsx(classes.scrollParent)}>
                                        <Col span={24}>
                                            <Row className={clsx(classes.customRow)}>
                                                <PrimaryTable
                                                    heads={componentPermisionHead}
                                                    width={true}
                                                    component={
                                                        <ComponentTable
                                                            changeComponentHandler={(data, e) => changeComponentHandler(data, e)}
                                                            type="edit"
                                                            emptyState={() => emptyState()}
                                                            showDetails={showDetails}
                                                            checkErrorComponentId={errorComponentId}
                                                            rows={featureData}
                                                            componentPermisionHead={componentPermisionHead}
                                                            loadTasks={() => dispatch({ type: crudActions.READ_DETAILS_START, id: roleId, url: "role" })}
                                                            featureComponentDetails={featureComponentDetails}
                                                            componentDetails={componentDetails}
                                                            component={componentData}
                                                            roleId={roleId}
                                                            changeComponentVisible={(data) => { changeComponentVisible(data) }}

                                                        />
                                                    }
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </TabPanel>
                                <TabPanel value={"Client"}>
                                    <Row className={clsx(classes.scrollParent)}>
                                        <Col span={24}>
                                            <Row className={clsx(classes.customRow)}>
                                                <PrimaryTable
                                                    heads={clientTaggingHead}
                                                    width={true}
                                                    component={
                                                        <ClientTable
                                                            heads={clientTaggingHead}
                                                            visible={clientVisible}
                                                            handleClientOpen={(data) => handleOpen(data)}
                                                            handleClientClose={(data) => handleClose(data)}
                                                            rows={readDetails.roleClients}
                                                            showDetails={false}
                                                            roleId={roleId}
                                                            loadTasks={() => dispatch({ type: crudActions.READ_DETAILS_START, id: roleId, url: "role" })}
                                                        />
                                                    }
                                                />
                                            </Row>
                                        </Col>
                                    </Row>
                                </TabPanel>
                            </TabContext>
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={'Add Feature'}
                    className={classes.closeBackGround}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => addFeature(e)}
                        >
                            <div className={classes.customFormFlex}>
                                <AutoCompleteComponent
                                    name={["Feature ", <span key={"Feature"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'featureName', 'name': 'Name' }, { 'key': 'module', 'name': 'Module', 'relation': 'module' }]}
                                    details={featureCustomDetails()}
                                    parentValue={featureObject()}
                                    onChange={(data) => changeHandler(data.id, 'featureId')}
                                    position={"bottom"}
                                    parentError={errorFeatureId}
                                />
                                <div className={clsx(classes.margin30t, classes.feautureCheckboxes)}>
                                    <Row>
                                        <Col span={5}>View</Col>
                                        <Col span={5}>Edit</Col>
                                        <Col span={5}>Create</Col>
                                        <Col span={6}>Delete</Col>
                                        <Col span={2} className={clsx(classes.textAlignRight)}>Full</Col>
                                    </Row>
                                    <Row className={clsx(classes.feautureCheckboxesRow)}>
                                        <Col span={5}>
                                            <Checkbox checked={form.view} name={"view"} onChange={(e) => changeHandler(e)} />
                                        </Col>
                                        <Col span={5}>
                                            <Checkbox checked={form.edit} name={"edit"} onChange={(e) => changeHandler(e)} />
                                        </Col>
                                        <Col span={5}>
                                            <Checkbox checked={form.create} name={"create"} onChange={(e) => changeHandler(e)} />
                                        </Col>
                                        <Col span={6}>
                                            <Checkbox checked={form.deletable} name={"deletable"} onChange={(e) => changeHandler(e)} />
                                        </Col>
                                        <Col span={2}>
                                            <FormControlLabel
                                                label=""
                                                labelPlacement="end"
                                                name={"full"}
                                                className={clsx(classes.switchAlignfont14, classes.switchAlign, classes.availableClients, classes.bold)}
                                                control={
                                                    <Switch
                                                        className={clsx(classes.customSwitch)}
                                                        size="small" name="full" onChange={(e) => changeHandler(e)} checked={form.full} />
                                                }
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Button
                                    key="add"
                                    type='submit'
                                    color='primary'
                                    variant="contained"
                                    className={clsx(classes.modalBtn, { [classes.loading]: createLoader })}

                                >Save</Button>
                            </div>
                        </Box>
                    }
                />
            </div>
        </React.Fragment >
    )

}

export default RoleEdit;


